<script lang="ts" setup>
import { useConfirm } from '@/composable/useConfirm'

const { confirmConfig } = useConfirm()
</script>

<template>
  <v-dialog v-model="confirmConfig.isOpen" class="dialog-modal">
    <v-card>
      <!--    :is-open="confirmConfig.isOpen"-->
      <!--    :hide="confirmConfig.cancel"-->
      <!--    dialog-classes="sm:max-w-md px-4 pt-5 pb-4 sm:p-6"-->
      <v-card-title class="text-white bg-primary d-flex justify-space-between align-center">
        {{ confirmConfig.message }}
      </v-card-title>
      <v-card-text>
        <p class="leading-normal text-gray-500 dark:text-gray-300">
          {{ confirmConfig.body }}
        </p>
      </v-card-text>
      <v-card-actions>
        <v-btn variant="base" class="w-full" @click="confirmConfig.cancel">
          {{ confirmConfig.cancelLabel }}
        </v-btn>

        <v-btn kind="danger" class="w-full" @click="confirmConfig.confirm">
          {{ confirmConfig.confirmLabel }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
